import apiClient from './apiClient';

export const ministriesApi = {
	getAll: async (orgId) => {
		try {
			const response = await apiClient.get(
				`/api/ministries/organization/${orgId}`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch ministries'
			);
		}
	},

	getOne: async (orgId, ministryId) => {
		try {
			const response = await apiClient.get(
				`/api/ministries/${ministryId}`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch ministry'
			);
		}
	},

	create: async (orgId, ministryData) => {
		try {
			const response = await apiClient.post(`/api/ministries`, {
				...ministryData,
				organizationId: orgId,
			});
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to create ministry'
			);
		}
	},

	update: async (orgId, ministryId, ministryData) => {
		try {
			const response = await apiClient.patch(
				`/api/ministries/${ministryId}`,
				ministryData
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to update ministry'
			);
		}
	},

	delete: async (ministryId) => {
		try {
			const response = await apiClient.delete(
				`/api/ministries/${ministryId}`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to delete ministry'
			);
		}
	},

	// Get ministry members
	getMembers: async (ministryId) => {
		try {
			const response = await apiClient.get(
				`/api/ministries/${ministryId}/users`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to fetch ministry members'
			);
		}
	},

	// Add members to ministry
	addMembers: async (ministryId, userIds) => {
		try {
			const response = await apiClient.post(
				`/api/ministries/${ministryId}/users`,
				{ userIds }
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to add ministry members'
			);
		}
	},

	// Remove member from ministry
	removeMember: async (ministryId, userId) => {
		try {
			const response = await apiClient.delete(
				`/api/ministries/${ministryId}/users/${userId}`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to remove ministry member'
			);
		}
	},

	checkins: {
		getAll: async (orgId, ministryId) => {
			try {
				const response = await apiClient.get(
					`/api/ministries/${ministryId}/checkins`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to fetch checkins'
				);
			}
		},

		create: async (ministryId, userIds) => {
			try {
				const response = await apiClient.post(
					`/api/ministries/${ministryId}/checkin`,
					{ userIds } // Send array of user IDs
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to check in'
				);
			}
		},

		checkout: async (ministryId, userIds) => {
			try {
				const response = await apiClient.patch(
					`/api/ministries/${ministryId}/checkout`,
					{ userIds } // Send array of user IDs
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to check out'
				);
			}
		},

		getStatus: async (ministryId) => {
			try {
				const response = await apiClient.get(
					`/api/ministries/${ministryId}/checkin-status`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message ||
						'Failed to get check-in status'
				);
			}
		},
	},

	reports: {
		getOverview: async (orgId) => {
			try {
				const response = await apiClient.get(
					`/api/ministries/organization/${orgId}/reports/overview`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message ||
						'Failed to fetch report overview'
				);
			}
		},

		getAttendance: async (orgId, params = {}) => {
			try {
				const response = await apiClient.get(
					`/api/ministries/organization/${orgId}/reports/attendance`,
					{ params }
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message ||
						'Failed to fetch attendance report'
				);
			}
		},

		getGrowth: async (orgId, timeframe = 'month') => {
			try {
				const response = await apiClient.get(
					`/api/ministries/organization/${orgId}/reports/growth`,
					{ params: { timeframe } }
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message ||
						'Failed to fetch growth report'
				);
			}
		},

		exportData: async (orgId, reportType, format = 'csv') => {
			try {
				const response = await apiClient.get(
					`/api/ministries/organization/${orgId}/reports/export`,
					{ params: { reportType, format }, responseType: 'blob' }
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message ||
						'Failed to export report data'
				);
			}
		},
	},
};
